export const ROUTE_STYLES = {
  run: { label: "Run / Route", color: "#FF8A1F", dash: null, end: "arrow", help: "Solid line with an arrow" },
  block: { label: "Block", color: "#FFFFFF", dash: null, end: "tee", help: "Solid line ending in a T bar" },
  motion: { label: "Motion (before snap)", color: "#C4B5FD", dash: "0.25 0.7", end: "arrow", help: "Dotted line with an arrow" },
};

export const BALL_STYLES = {
  snap: { label: "Snap", color: "#FACC15", dash: "0.5 0.5", duration: 0.3 },
  handoff: { label: "Handoff", color: "#FACC15", dash: "0.5 0.5", duration: 0.25 },
  pitch: { label: "Pitch", color: "#FACC15", dash: "0.5 0.5", duration: 0.5 },
  pass: { label: "Pass", color: "#00D2FF", dash: "1.4 0.8", duration: 0.8 },
};

export const CATEGORY_LABELS = { offense: "Offense", defense: "Defense", special: "Special Teams" };

export function textOn(hex) {
  const h = (hex || "#000000").replace("#", "");
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
  return 0.299 * r + 0.587 * g + 0.114 * b > 150 ? "#0B1528" : "#FFFFFF";
}
